import React from "react";
import { Box, FormControlLabel, Checkbox } from "@mui/material";
import { FieldArray } from "formik";

const CheckboxListFormSimple = ({
  orderFormFieldKey,
  orderFormFieldTouched,
  orderFormFieldError,
  value,
  options,
  handleChange,
  handleBlur,
}) => {
  return (
    <Box
      key={orderFormFieldKey}
      sx={{
        width: "100%",
      }}
    >
      <FieldArray name={orderFormFieldKey}>
        {({ push, remove }) => {
          return (
            <Box display={"flex"} flexDirection={"column"}>
              {(options || []).map(({ name, key }, i) => {
                const optionsKey = `${orderFormFieldKey}[${i}]`;
                return (
                  <FormControlLabel
                    key={optionsKey}
                    control={
                      <Checkbox
                        id={optionsKey}
                        name={optionsKey}
                        checked={(value || []).includes(key)}
                        onChange={(e) => {
                          e.target.checked
                            ? push(key)
                            : remove((value || []).indexOf(key));
                        }}
                      />
                    }
                    label={name || ""}
                  />
                );
              })}
            </Box>
          );
        }}
      </FieldArray>
    </Box>
  );
};

export default CheckboxListFormSimple;
